/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {getJsonFromUrl, isLZWKAPP, isTouchBottom} from '../utils'
import {
    Page,
    ClickLoadMore
} from '../components'
import {
    SearchSearchBar,
    SearchTitleBar,
    SearchLiveroom,
    SearchChannel,
    SearchLecture
} from '../components/search'
import IntroItem from '../pages/mywkPage/NewIntroItem'
import '../styles/search/SearchPage.css'

class SearchPage extends React.Component {

    constructor() {
        super();
        this.state = {
            loading: false,
            recommends: null,
        }
        this.recommendInviterId = isLZWKAPP() ? '44813776' : '46548354'
    }

    componentDidMount() {
        // return
        const data = getJsonFromUrl();
        /*const routerLocation = browserHistory.getCurrentLocation();
        const currentPath = routerLocation.pathname;
        const landingPath = window.landingPath;
        if (currentPath !== landingPath) {
            window.location = routerLocation.pathname + routerLocation.search
        }*/
        const {search} = this.props;
        if (data.q){
            this.props.dispatch({
                type: 'SEARCH_SEARCH_TEXT',
                payload: data.q
            });

            //GET LIVEROOM INDEX
            axios.get('/api/board/search',{
                params: {
                    q: data.q,
                    type: 'liveroom',
                }
            }).then(res => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'SEARCH_LIVEROOM_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'SEARCH_LIVEROOM_LIST',
                        payload: res.data.data.records
                    });
                    if (this.state.showLoading){
                        this.setState({
                            showLoading: false
                        });
                    }
                }
            });

            //GET CHANNEL INDEX
            axios.get('/api/board/search',{
                params: {
                    q: data.q,
                    type: 'channel',
                }
            }).then(res => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'SEARCH_CHANNEL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'SEARCH_CHANNEL_LIST',
                        payload: res.data.data.records
                    });
                    if (this.state.showLoading){
                        this.setState({
                            showLoading: false
                        });
                    }
                }
            });

            //GET LECTURE INDEX
            axios.get('/api/board/search',{
                params: {
                    q: data.q,
                    type: 'lecture',
                }
            }).then(res => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'SEARCH_LECTURE_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'SEARCH_LECTURE_LIST',
                        payload: res.data.data.records
                    });
                    if (this.state.showLoading){
                        this.setState({
                            showLoading: false
                        });
                    }
                }
            });

            this.props.dispatch({
                type: 'UPDATE_SHARE_DATA',
                payload: {
                    title: data.q !== '' ? `关于"${data.q}"的内容` : '微课搜索',
                    desc: '我在微课找到了这些有趣的课程！',
                    imgUrl: 'http://o9u3z67p5.qnssl.com/static/img/lizhiweike.5575c0ed4c95.png',
                    type: 'link',
                    link: window.location.origin + window.location.pathname + `?q=${encodeURIComponent(data.q)}`,
                }
            });
        }

        this.fetchRecommends ()

        this.scroll_method = () => {
            let shouldGet = isTouchBottom(30)
            if (shouldGet && this.props.search.search_text !== '' && this.props.search.lecture && this.props.search.lecture.has_more){
                if (!this.state.loading){
                    this.setState({
                        loading: true
                    });
                    //GET LECTURE MORE
                    axios.get('/api/board/search',{
                        params: {
                            q: this.props.search.search_text,
                            type: 'lecture',
                            offset: this.props.search.lecture && this.props.search.lecture.next_offset,
                        }
                    }).then(res => {
                        if (res.data.code === 0){
                            this.props.dispatch({
                                type: 'SEARCH_LECTURE_INIT',
                                payload: res.data.data
                            });
                            let list = this.props.search.lecture_list.concat(res.data.data.records);
                            this.props.dispatch({
                                type: 'SEARCH_LECTURE_LIST',
                                payload: list
                            });
                            this.setState({
                                loading: false
                            });
                        }
                    })
                }
            }
        };

        window.addEventListener('scroll',this.scroll_method);
    }

    fetchRecommends () {
        // return
        axios.get(`/api/recommend/channels`, {
            params: {
                limit: 6
            }
        })
            .then(res => {
                if (res.data.code === 0 && res.data.data.channels.length > 0) {
                    this.setState({ recommends: res.data.data.channels })
                }
            })
            .catch(res => console.log(res, 'err'))
        // const channels = ['90120', '111702', '57046', '72194', '79990', '97636']
        // const promises = channels.map(item => this.fetchRecommendChannel(item))
        // Promise.all(promises)
        //     .then(res => {
        //         this.setState({ recommends: res })
        //     })
        //     .catch(res => console.log(res, 'err'))
    }

    fetchRecommendChannel (id) {
        // return
        return axios.get(`/api/channel/${id}/info?st=search_recommend&inviter_id=${this.recommendInviterId}`)
            .then(res => {
                const data = res.data.data
                if (res.data.code === 0) {
                    return {
                        ...data.channel,
                        nominal_money: data.channel.promoprice && data.channel.promoprice.price || data.channel.money,
                        popular: data.stats_info.popular,
                        lecture_count: data.stats_info.lecture_count,
                    }
                } else {
                    throw new Error('api error')
                }
            })
    }

    componentWillUnmount (){
        // return
        this.scroll_method && window.removeEventListener('scroll',this.scroll_method);
    }

    render() {
        const {search} = this.props;

        const loadingstatus = {
            ended: this.props.search.lecture_init && !this.props.search.lecture.has_more,
            loading: this.state.loading,
            has_more: this.props.search.lecture_init && this.props.search.lecture.has_more,
            loadMethod: () => {}
        };

        let init = search.liveroom_init && search.channel_init && search.lecture_init;
        let isNotSearchResult = search.liveroom_list && search.liveroom_list.length === 0 &&
            search.channel_list && search.channel_list.length === 0 &&
            search.lecture_list && search.lecture_list.length === 0;

        const isShowRecommends = !init && this.state.recommends && getJsonFromUrl().q == null

        return (
            <Page>
                <div className="search-page">

                    <SearchSearchBar/>

                    {init && isNotSearchResult &&
                    <div className="search-page-nothing">
                        <div className="search-page-nothing-wrap">
                            <img src="https://static-cos.lycheer.net/picture/12209467_e13e128f6c6ed1040a3f4f907d849431.jpg" />
                            <p>抱歉，没有找到你想要的内容</p>
                            <a style={{width: '100%', display: 'block'}} href="/"><button>返回首页</button></a>
                        </div>
                    </div>
                    }

                    {
                        isShowRecommends && (
                            <div className="recommends-wrap">
                                <div className="title">大家都在搜</div>
                                <div className="recommends">
                                    {
                                        isShowRecommends && (
                                            this.state.recommends.map(item => {
                                                return (
                                                    <IntroItem
                                                        key={item.id}
                                                        type="channel"
                                                        content={item}
                                                        attr="search_recommend"
                                                        st="search_recommend"
                                                        inviterId={this.recommendInviterId}
                                                    />
                                                )
                                            })
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }

                    <div className="search-page-container">
                        {/* <div style={{
                            textAlign: "center",
                            fontSize: "14px",
                            paddingTop: "15px",
                            color: "#666"}}>
                            搜索引擎正在升级优化，近期将无法使用。
                        </div> */}


                        {search.liveroom_init && search.liveroom_list && (search.liveroom_list.length > 0) &&
                        <div>
                            <SearchTitleBar name={'店铺'} hasMore={search.liveroom.has_more || search.liveroom_list.length > 4}/>
                            <SearchLiveroom />
                        </div>
                        }

                        {search.channel_init && search.channel_list && (search.channel_list.length > 0) &&
                        <div>
                            <SearchTitleBar name={'专栏'} hasMore={search.channel.has_more || search.channel_list.length > 3}/>
                            <SearchChannel />
                        </div>
                        }

                        {search.lecture_init && search.lecture_list && (search.lecture_list.length > 0) &&
                        <div>
                            <SearchTitleBar name={'课程'}/>
                            <SearchLecture />
                            <ClickLoadMore loadingstatus={loadingstatus}/>
                        </div>
                        }

                    </div>

                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    search: state.search
}))(SearchPage)



// WEBPACK FOOTER //
// ./src/pages/SearchPage.js